import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=a8867b88&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Buy.vue?vue&type=style&index=1&id=a8867b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8867b88",
  null
  
)

export default component.exports